import { takeLatest, throttle } from 'redux-saga/effects';
import { matTrendSelectorFlow } from './matTrendSelectorFlow';
export const matTrendSelectorSagas = [
	throttle(1000, 'context/triggerMatTrendSelector', matTrendSelectorFlow),
];
